// extracted by mini-css-extract-plugin
export default {"price":"o5-z","onSale":"p5-z","msrpLabelPrice":"q5-z","msrpLabel":"r5-z","originalPrice":"s5-z","percentOff":"t5-z"};